export default function () {
  return [
            [
          'a',
          'SOCIAL',
          ':',
          'project',
          '',
          'title',
          ':',
          'AI Economy',
          '',
          'priority',
          '=',
          '1',
          '',
          'votes',
          '=',
          '247',
          '',
          'comments',
          '=',
          '144',
          '',
          'clones',
          '=',
          '24',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Post',
          ':',
          'Process Repository Database',
          '',
          'subtitle',
          ':',
          'welcome to ai web',
          '',
          'body',
          ':',
          `AI super productivity app.
Add incentive check lists to trigger ai innovators worldwide.
Or add your services to contribute to world's innovation projects.`,
          '',
          'signature',
          ':',
          `clone free ai world apps:
github.com/ai-accelerator`,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          'b',
          'RATES',
          ':',
          'money',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Post',
          ':',
          'Recombinant Process Repos',
          '',
          'help',
          ':',
          'Check if service rate is in project range',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          'c',
          'DOCS',
          ':',
          'terms',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( sc-Docs == "ready" ) { pc-State = "Ok" } else { pc-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        // ['1','Post',':','Toronto W3AI News','','posts',':','24','','comments',':','36','','','','','','','','','','','','','','','\n'],
        [
          'd',
          'BOOK',
          ':',
          'done',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( sd-Book == "open" ) { pd-State = "Ok" } else { pd-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        // ['1','Gantt',':','calendar','','','','','','','','','','','','','','','','','','','','','','','\n'],
        [
          'e',
          'INPUT',
          ':',
          'create',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( se-Input == "match" ) { pe-State = "Ok" } else { pe-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          'f',
          'STEPS',
          ':',
          'plan',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Cmd',
          ':',
          '= if ( sf-Steps == "ok" ) { pf-State = "Ok" && cmd = "gcloud firestore create-indexes index.yaml"} else { pf-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          'g',
          'OUTPUT',
          ':',
          'test',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Order',
          ':',
          '= if ( sg-Output == "created" ) { pg-State = "Ok" && request = "@QA-Team : run tests"} else { pg-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          'h',
          'PAY',
          ':',
          'paid',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],
        [
          '1',
          'Verbal',
          ':',
          '= if ( sh-Pay == "cashed" ) { ph-State = "Done" && verbal = "Thanks!"} else { ph-State = "Feedback" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '\n',
        ],

  ]
}